import { SVGProps, Ref, forwardRef } from 'react';

export const CircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 23C3.75 23 1 17.5 1 12S3.75 1 12 1s11 5.5 11 11-2.75 11-11 11m-7.211-4.59C3.424 16.772 2.8 14.483 2.8 12s.624-4.772 1.989-6.41C6.106 4.01 8.308 2.8 12 2.8s5.894 1.21 7.211 2.79C20.576 7.228 21.2 9.517 21.2 12s-.624 4.772-1.989 6.41C17.894 19.99 15.692 21.2 12 21.2s-5.894-1.21-7.211-2.79"
                fill="currentColor"
            />
        </g>
    </svg>
));
CircleOutlinedSize24Glyph.displayName = 'CircleOutlinedSize24Glyph';
